export const toCents = (value: number) => Math.round(value * 100);
